<template>
  <div id="tfl-about" class="tfl-about outermost-layer" v-if="bodyWidth">
    <top-nav></top-nav>
    <!--轮播图-->
    <div class="about-banner">
      <!--左右切换剪头-->
      <!-- <div class="banner-arrow left"></div>
      <div class="banner-arrow right"></div>-->
      <!--指标-->
      <div class="banner-carousel">
        <span
          v-bind:class="{
            active:
              currentIndex === carouselList.length
                ? index === 0
                : currentIndex === index,
          }"
          v-for="(item, index) in carouselList"
          :key="item.key"
          @click="carouselClick(index)"
        ></span>
      </div>
      <!--图片-->
      <div class="banner-image">
        <ul
          class="image-ul"
          :style="{ width: bannerWidth + 'px' }"
          @mouseover="removeAutoPlay()"
          @mouseout="autoPlay()"
        >
          <li
            v-bind:class="{ active: currentIndex === index }"
            v-for="(item, index) in bannerList"
            :key="item.key"
            :style="{ width: bodyWidth + 'px' }"
          >
            <img :src="item.src" />
          </li>
        </ul>
      </div>
    </div>
    <!--内容区-->
    <div class="about-content">
      <!--发展现状-->
      <div class="content-develop">
        <div class="develop-item" v-for="item in developList" :key="item.id">
          <div class="item-num">
            <span class="big-show">{{ item.num }}</span>
            <span>{{ item.unit }}+</span>
          </div>
          <div class="item-text">{{ item.text }}</div>
        </div>
      </div>
      <!--发展历程-->
      <div class="content-progress">
        <div class="progress-title">{{ langData.progress }}</div>
        <div class="progress-tree" v-for="item in progressData" :key="item.id">
          <div class="tree-item">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-content" v-for="nav in item.content" :key="nav.id">
              <div v-if="item.content && nav.text">
                <span class="tree-node"></span>
                <span
                  class="tree-text"
                  :class="
                    getLang(
                      { en: 'entree-text', zh: '' },
                      nav.code % 2 ? 'left' : 'right'
                    )
                  "
                  v-html="nav.text"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--品牌介绍-->
      <div class="content-brand">
        <div class="brand-title">{{ langData.brand }}</div>
        <div class="brand-content">
          <div
            class="brand-item"
            v-for="(item, index) in brandList"
            :key="item.id"
          >
            <div
              style="width: 100%; height: 100%; overflow: hidden"
              :style="{
                background: 'url(' + item.bgcImg + ') no-repeat 100% 100%',
              }"
            >
              <div class="item-introduce" v-if="index % 2 !== 0">
                <div class="introduce-right">
                  <img :src="item.src" />
                </div>
                <div
                  class="introduce-left"
                  :class="getLang({ en: 'enintroduce-left', zh: '' })"
                  :style="item.style"
                >
                  <div class="left-title">
                    <img
                      :src="item.logo"
                      :style="{
                        widht: index == 1 ? '274px' : '',
                      }"
                    />
                    <span :style="{ 'margin-top': index === 3 ? '14px' : 0 }">{{
                      item.title
                    }}</span>
                  </div>
                  <div class="left-text" v-html="item.content"></div>
                </div>
              </div>
              <div class="item-introduce" v-else>
                <div
                  class="introduce-left"
                  :class="getLang({ en: 'enintroduce-left', zh: '' })"
                  :style="item.style"
                >
                  <div class="left-title">
                    <img :src="item.logo" />
                    <span>{{ item.title }}</span>
                  </div>
                  <div class="left-text" v-html="item.content"></div>
                </div>
                <div class="introduce-right">
                  <img :src="item.src" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--精彩案例-->
      <wonderful-case></wonderful-case>
      <!--新闻资讯-->
      <div class="content-news" v-if="newsList.length">
        <div class="news-title">{{ langData.news }}</div>
        <div class="news-content">
          <div class="inner-content">
            <div class="news-item" v-for="item in newsList" :key="item.id">
              <div class="news-banner" @click="goDetail(item)">
                <img
                  style="width: 399px; height: 217px"
                  class="news-img"
                  :src="item.coverImage"
                />
              </div>
              <!-- <div
                class="news-suntitle tfl-ellipsis"
                :title="item.title"
                v-html="item.title"
              ></div> -->
              <div
                class="news-suntitle tfl-ellipsis"
                v-html="langEn ? item.EnTitle : item.title"
                :title="langEn ? item.EnTitle : item.itle"
              ></div>

              <div class="news-date">{{ item.date }}</div>
              <!-- <div class="item-title tfl-ellipsis" v-html="item.title" @click="goNewsDetail(item)"></div>
              <div class="item-date">
                <span class="date-month">{{item.month}}</span>
                <span class="date-year">{{item.year}}</span>
              </div>
              <div class="item-text">{{item.suntitle}}</div>-->
            </div>
            <div class="news-item empty"></div>
            <div class="news-item empty"></div>
          </div>
        </div>
        <!--添加按钮-->
        <div class="news-add">
          <span>+</span>
        </div>
      </div>
    </div>
    <!--footer-->
    <bottom-navigation></bottom-navigation>
  </div>
</template>

<script>
import "@/assets/css/about.css";
import {
  bannerList,
  developList,
  progressData,
  brandList,
} from "../../config/dictionary.js";
import TopNavigation from "@/components/TopNavigation.vue";
import WonderfulCase from "@/components/WonderfulCase.vue";
import BottomNavigation from "@/components/BottomNavigation.vue";
import biglogo from "@/assets/img/brand/biglogo.png";
import { getLang } from "@/utils/index.js";
export default {
  name: "about",
  components: {
    topNav: TopNavigation,
    wonderfulCase: WonderfulCase,
    bottomNavigation: BottomNavigation,
  },
  data() {
    return {
      getLang,
      bannerList: [],
      carouselList: [],
      developList: [],
      progressData: {},
      brandList: [],
      bodyWidth: 0,
      currentIndex: 0,
      bannerWidth: 0,
      autoPlayTimer: null,
      autoPlayTime: 3000,
      biglogo,
      newsList: [],
    };
  },
  computed: {
    langData() {
      return this.$t("About");
    },
    langEn() {
      return this.$store.state.dynamic.lang === "en";
    },
  },
  methods: {
    goDetail(item) {
      this.$router.push({
        path: `/DynamicDetail/${item.id}`,
      });
    },
    carouselClick(index) {
      this.currentIndex = index;
      const el = document.querySelector(".image-ul");
      el.style.left = -index * this.bodyWidth + "px";
    },
    autoPlay() {
      const _this = this;
      // 计算宽度
      this.autoPlayTimer = setInterval(() => {
        _this.bodyWidth = document.body.offsetWidth;
        _this.bannerWidth = _this.bannerList.length * _this.bodyWidth;
        if (_this.currentIndex === _this.bannerList.length - 1) {
          const el = document.querySelector(".image-ul");
          _this.currentIndex = 0;
          el.style.transition = "none";
          el.style.left = 0;
        }
        setTimeout(() => {
          const el = document.querySelector(".image-ul");
          _this.currentIndex++;
          el.style.transition = "all 0.5s ease";
          el.style.left = -_this.currentIndex * _this.bodyWidth + "px";
        }, 500);
      }, this.autoPlayTime);
    },
    removeAutoPlay() {
      this.autoPlayTimer && clearInterval(this.autoPlayTimer);
    },
    getNewsList() {
      let _this = this;
      var type = null;
      if (this.langEn) {
        type = 1;
      } else {
        type = 0;
      }
      this.$httpGet("GetNews", {
        Pageindex: 0,
        Pagenum: 3,
        keyword: "",
        type: type,
      }).then((res) => {
        if (!res || !res.rows.length) return;
        const newList = [];
        console.log(res.rows);
        res.rows.forEach((row) => {
          // let timeArr = row.Createtime.split("-");
          newList.push({
            id: row.Id,
            title: row.Title,
            EnTitle: row.EnTitle,
            suntitle: row.Subheading,
            date: row.Createtime,
            coverImage: row.CoverImage,
            // year: timeArr[0],
            // month: timeArr[1] + "-" + timeArr[2],
            // content: ""
          });
        });
        _this.newsList = newList;
        // console.log(this.newList);
      });
    },
    goNewsDetail(item) {
      this.$router.push({
        path: `/DynamicDetail/${item.id}`,
      });
    },
  },
  mounted() {
    // 整理参数
    let timer = setInterval(() => {
      if (!document.body.offsetWidth) return;
      clearInterval(timer);
      this.bannerList = bannerList;
      this.bodyWidth = document.body.offsetWidth;
      this.bannerWidth = this.bannerList.length * this.bodyWidth;
      this.carouselList = bannerList.slice(0, bannerList.length - 1);
      this.developList = developList;
      this.progressData = progressData;
      this.brandList = brandList;
      this.autoPlay();
      this.getNewsList();
    });
  },
  destroyed() {
    this.autoPlayTimer && clearInterval(this.autoPlayTimer);
  },
};
</script>


// WEBPACK FOOTER //
// src/views/About.vue